<template>
  <div class="image-block-container">
    <b-container fluid>
      <b-row>
        <template v-if="imageOnRight">
          <b-col md="6" class="left-text">
            <div class="image-block-text">
              <h3>{{ title }}</h3>
              <p v-html="text" />
            </div>
          </b-col>
          <b-col
            :style="{ 'background-image': `url(${imageUrl})` }"
            md="6"
            class="image-block-img img-left"
          />
        </template>
        <template v-else>
          <b-col
            :style="{ 'background-image': `url(${imageUrl})` }"
            md="6"
            class="image-block-img img-right"
          />
          <b-col md="6" class="text-block">
            <div class="image-block-text">
              <h3>{{ title }}</h3>
              <p v-html="text" />
            </div>
          </b-col>
        </template>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    name: 'ImageBlockComponent',
    props: {
      imageUrl: {
        type: String,
        default: '',
      },
      imageOnRight: {
        default: false,
        type: Boolean,
      },
      title: {
        default: '',
        type: String,
      },
      text: {
        default: '',
        type: String,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';
  @import '~@triotech/vue-core/src/scss/compass';
  @import 'compass/css3/transition';
  @import 'compass/css3/transform';

  .image-block-container {
    margin-bottom: 2rem * 2;

    .left-text {
      margin-right: 15px;
    }

    .image-block-img {
      min-height: 300px;
      background: {
        position: center;
        size: cover;
        repeat: no-repeat;
      };

      @include transition(transform .5s);

      &.img-right {
        margin-right: -15px;
        margin-left: 0;
      }

      &.img-left {
        margin-right: 0;
        margin-left: -15px;
      }
    }

    .image-block-text {
      padding: 4rem;

      h3 {
        margin-bottom: 2rem;
        font-size: 1.2rem;
        position: relative;
        color: $primary;
        font-weight: bold;
      }

      p {
        color: $black;
      }

      .see-more {
        display: block;
        width: 100%;
      }
    }
  }

  @include editable-max-width(1100px) {
    .image-block-container {
      .image-block-text {
        padding: 1rem 2rem;
      }
    }
  }

  @include editable-max-width(768px) {
    .image-block-container {
      margin-bottom: 2rem;

      .image-block-img {
        width: 100%;
        margin-bottom: 2rem;
      }
    }
  }

  @include editable-max-width(425px) {
    .image-block-container {
      .image-block-img {
        &.img-right {
          margin-right: 0;
          margin-left: 0;
        }

        &.img-left {
          margin-right: 0;
          margin-left: 0;
        }
      }

      .image-block-text {
        padding: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ImageBlock.vue